import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircle } from '@phosphor-icons/react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { TemporaryDrawer } from '../Drawer';
import { AuthContext } from '../../providers/auth';
import { UserDataContext } from '../../providers/userData';
import { accountsApi } from '../../services/accountsApi';
import { LoadingContext } from '../../providers/loading';
import { LoadingScreen } from '../LoadingScreen';
import { useTheme } from '../../providers/theme';
import { LanguageSwitch } from '../LanguageSwitch';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function Header() {
  const handlerLogo = require('../../assets/images/logoHandler.png');
  const navigate = useNavigate();

  const { userData } = useContext(UserDataContext);
  const { setState } = useContext(AuthContext);
  const { theme } = useTheme();
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();


  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = async () => {
    setIsLoading({ value: true });
    await accountsApi.delete('/deactivate_token', {
      headers: {
        'Authorization': `Bearer ${userData.token}`
      }
    })
      .then(() => {
        localStorage.removeItem('user');
        setIsLoading({ value: true });
        setState({ userIsLogged: false });
        navigate('/');
      })
      .catch(error => console.log(error));
  };

  return (
    <>
      <div style={{ padding: '0px 37px', height: '65px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #DEDEDE' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 30 }}>
          <TemporaryDrawer />
          <Tooltip title={t('group-list-header')}>
            <img
              onClick={() => navigate('/contracts')}
              src={handlerLogo}
              alt="esmart-logo"
              style={{ height: '40px', cursor: 'pointer' }}
            />
          </Tooltip>
        </div>

        <div style={{ display: 'flex', gap: 30, alignItems: 'center' }}>
          <LanguageSwitch />

          <Button
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <UserCircle size={35} color={theme.colors.main} />
          </Button>
        </div>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItem onClick={() => logout()}>Logout</MenuItem>
        </Menu>
      </div>

      {isLoading && (
        <LoadingScreen isVisible={isLoading.value} />
      )}
    </>
  );
}
